import { useCallback, useRef } from "react";
import { useReactToPrint } from "react-to-print";

export const useReceiptPrint = () => {
  const printRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Comprovante Pix",
    pageStyle: `
      @page { size: auto; margin: 12mm; }
      html, body { color: #1a1a1a !important; }
    `,
  });

  const print = useCallback(() => {
    if (!printRef.current) return;
    handlePrint();
  }, [handlePrint]);

  return { printRef, print };
};
